import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-liste-admin2';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerListeAdmin2Effects {

    BenutzerListeAdmin2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_LISTE_ADMIN2),
        mergeMap((x: ac.GetBenutzerListeAdmin2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerListeAdmin2().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerListeAdmin2ErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerListeAdmin2FehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminQueryService);
        }
        return this.service;
    }
}
